var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": _vm.blogHeaderTitle,
      "subTitleText": 'The Project Spectrum Cyber Advisory Team is one of the best – and the group regularly writes about key issues that affect every user in the cyber realm. Get key insights from experts on the latest developments affecting your work in cyberspace. Check this space regularly – we update it often!'
    }
  }), _vm.isRecentBlogs ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cybercorner'
      }
    }
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to Cyber Corner ")])], 1) : _vm._e()], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 mb-5 section-content"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5 px-lg-5 px-xl-5"
  }, [_vm._m(0), _vm.totalRows > 0 ? _c('div', {
    staticClass: "mb-5"
  }, [_c('SearchControlWidget', {
    attrs: {
      "inputTextPlaceholder": 'Enter blog title here',
      "searchControlHeight": '100px',
      "searchQueryInputHandler": _vm.updateSearchQuery
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "row m-0 mb-4"
  }, _vm._l(_vm.displayedBlogItems, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-12 col-md-6 col-lg-6 col-xl-6 p-2"
    }, [_c('BlogPreviewBadge', {
      key: item.id,
      attrs: {
        "id": item.id,
        "image": item.mainImage,
        "imageDescription": item.photoDescription,
        "title": item.title,
        "caption": item.headLine,
        "date": item.date,
        "blogPage": String(_vm.currentPage),
        "query": _vm.searchQuery,
        "isRecentBlogs": _vm.isRecentBlogs
      }
    })], 1);
  }), 0), _vm.totalRows > 0 && _vm.totalRows > _vm.perPage ? _c('div', {
    staticClass: "mb-5"
  }, [_c('b-pagination', {
    staticClass: "ml-0",
    attrs: {
      "id": "blog-pagination",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "page-click": _vm.pageClicked
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e(), _vm.displayedBlogItems.length === 0 ? _c('div', {
    staticClass: "row m-0 w-100 mb-4",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex justify-content-center align-items-center empty-blog-message text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.blogItems.length === 0 ? `There are no blogs available within the last six months` : `There are no blog items available for the blog search: 
            <br>
            &quot${_vm.searchQuery}&quot
            `)
    }
  })]) : _vm._e(), _vm.isRecentBlogs ? _c('div', {
    staticClass: "d-flex flex-row justify-content-center mb-5"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": _vm.goToBlogArchives
    }
  }, [_vm._v(" View Blog Archives ")])], 1) : _c('div', {
    staticClass: "d-flex flex-row justify-content-center mb-5"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": _vm.gotToRecentBlogs
    }
  }, [_vm._v(" Back To Recent ")])], 1)])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 d-flex justify-content-center section-title"
  }, [_c('span', [_vm._v("READ OUR BLOGS")])]);

}]

export { render, staticRenderFns }